import { render, staticRenderFns } from "./SDL.vue?vue&type=template&id=083ed83e&scoped=true&"
import script from "./SDL.vue?vue&type=script&lang=js&"
export * from "./SDL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083ed83e",
  null
  
)

export default component.exports